import {Toast} from "antd-mobile";

const bottomToast = (content) => {
    Toast.show({
        content: content,
        position: 'bottom',
    })
}

export {bottomToast}